import { privateRequest, type ApiResponse } from "../axios";
import { saveAsExcelFile } from "../excelService/excelSevice";

const ENDPOINTS ={
    EXCEL_EXPORT:"api/GC/UserLocationReport/Export",
}

const exportLocationReport = async (data:any) => {   
    const res = await privateRequest.post<ApiResponse<any>>( 
        ENDPOINTS.EXCEL_EXPORT,
        data,
        { responseType: "arraybuffer" }
    )
    saveAsExcelFile(res, "LocationReport");
}

const sendMailLocationReport = async (data:any) => {   
    const res = await privateRequest.post<ApiResponse<any>>( 
        ENDPOINTS.EXCEL_EXPORT,
        data,
    )
   return res.data;
}

const locationReportService = {
    exportLocationReport,
    sendMailLocationReport
}

export default locationReportService;